import React from 'react';
import styles from './Title.css';


const Title = () => {
    return (
        <div>
            <p className={styles.mainTitle}>PALETY ŁADUNKOWE</p>
            <p className={styles.subtitle}>PRZEDSIĘBIORSTWO ŻAKO</p>
        </div>
    )
};

export default Title;


// WEBPACK FOOTER //
// ./src/components/Title/Title.js